import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-action-cell-renderer',
  template: `
    <div class="action-buttons d-flex gap-2 align-items-center justify-content-center">
      <button
        class="btn btn-outline-primary btn-sm"
        (click)="onEdit()"
        title="Edit User"
        type="button">
        <i class="fas fa-edit"></i>
      </button>

      <!-- Delete Button - Only show when status is inactive -->
      <button
        class="btn btn-outline-primary btn-sm"
        (click)="onDelete()"
        title="Delete User"
        type="button"
        *ngIf="canShowDelete">
        <i class="fas fa-trash"></i>
      </button>

      <!-- Show disabled delete button when status is active -->
      <span [title]="'Please Inactive user first then system allow to delete user.'">
        <button
          class="btn btn-outline-secondary btn-sm"
          type="button"
          *ngIf="!canShowDelete"
          disabled>
          <i class="fas fa-trash text-muted"></i>
        </button>
      </span>
    </div>`,

})
export class ActionCellRendererComponent implements ICellRendererAngularComp {
  public params!: ICellRendererParams;
  canShowDelete: boolean = false;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.updateDeleteVisibility();
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.updateDeleteVisibility();
    return true;
  }

  private updateDeleteVisibility(): void {
    // Check if delete should be shown based on status (only show when inactive)
    if (this.params.data && this.params.data.hasOwnProperty('isActive')) {
      // Delete button is only visible when status is inactive (isActive === false)
      this.canShowDelete = this.params.data.isActive === false;
    } else {
      // If no isActive property, show delete button (backward compatibility)
      this.canShowDelete = true;
    }
  }

  onEdit(): void {
    if (this.params.context && this.params.context.editUser) {
      this.params.context.editUser(this.params.data);
    }
  }

  onDelete(): void {
    if (this.params.context && this.params.context.deleteUser) {
      this.params.context.deleteUser(this.params.data);
    }
  }
}